import Button, { LinkButton as AtlaskitLinkButton } from '@atlaskit/button/new';
import { token } from '@atlaskit/tokens';
import Textfield from '@atlaskit/textfield';
import { styled } from 'styled-components';
import { Dimensions, Font } from 'components/visuals';

export const LinksContainer = styled.div`
  border-bottom: 1px solid ${token('color.border', '#B3B9C4')};
  padding: ${Dimensions.units(1.5)}px 0;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
`;

export const HeaderLinksWrapper = styled.div`
  display: flex;
  align-items: center;
  a + a {
    margin-left: 8px;
    padding-left: 8px;
    border-left: 1px solid ${token('color.border', '#B3B9C4')};
  }
`;

export const HeaderContainer = styled(LinksContainer)<{
  bottomLine?: boolean;
  flexDirectionColumn?: boolean;
}>`
  ${({ bottomLine }) => !bottomLine && 'border-bottom: none;'}
  ${({ flexDirectionColumn }) => flexDirectionColumn && 'flex-direction: column;'}
  padding-left: ${Dimensions.units(1)}px;
  margin-bottom: ${Dimensions.units(3.625)}px;
`;

export const PageTitle = styled.h2`
  margin-top: ${Dimensions.units(11)}px;
  margin-bottom: ${Dimensions.units(1.5)}px;
  font-weight: 500;
  font-size: 29px;
  font-family: ${Font.displayFamily};
`;

export const PageH3Header = styled.h3`
  color: ${token('color.text', '#172B4D')};
  font-size: 24px;
  margin-top: ${Dimensions.units(3.75)}px !important;
  margin-bottom: ${Dimensions.units(2)}px;
  font-weight: 500;
  font-family: ${Font.displayFamily};
  letter-spacing: 0.3px;
`;

export const LinkButton = styled(AtlaskitLinkButton)`
  position: relative;
  &:not(:last-child):after {
    content: '';
    position: absolute;
    right: 0;
    top: 6px;
    background-color: ${token('color.text', '#172B4D')};
    opacity: 0.4;
    width: 1px;
    height: ${Dimensions.units(2.5)}px;
  }
`;

export const LookupErrorBanner = styled.div`
  border: 1px solid ${token('color.icon.danger', '#F15B50')};
  border-radius: 3px;
  margin: ${Dimensions.units(2.5)}px 0px;
  display: flex;
  align-items: center;
`;

export const ErrorBody = styled.div`
  display: flex;
  align-items: center;
  margin-left: ${Dimensions.units(1.25)}px;
`;

export const FormGroup = styled.div`
  margin-left: ${Dimensions.units(2.5)}px;
  margin-top: ${Dimensions.units(5)}px;
`;

export const LookupFormGroup = styled.div`
  margin-left: ${Dimensions.units(2.5)}px;
  margin-top: ${Dimensions.units(5)}px;
  display: flex;
  flex-direction: column;
  gap: ${Dimensions.units(1)}px;
`;

export const LookRowContainer = styled.div`
  display: flex;
  gap: ${Dimensions.units(2.25)}px;
  align-items: baseline;
`;

export const RowContainer = styled.div`
  display: flex;
  margin-bottom: ${Dimensions.units(3.5)}px;
  gap: ${Dimensions.units(2.25)}px;
  width: ${Dimensions.units(57)}px;
`;

export const LabelWrapper = styled.div`
  display: flex;
  justify-content: right;
  align-items: center;
  width: ${Dimensions.units(16)}px;
  height: ${Dimensions.units(4.25)}px;
  min-width: ${Dimensions.units(16)}px;
  text-align: right;
  word-break: keep-all;
  font-size: 14px !important;
`;

export const FormLabel = styled.label`
  font-size: 14px;
`;

export const TextfieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const DescriptionLabel = styled.label`
  font-size: 14px;
  color: ${token('color.icon', '#44546F')};
  margin-top: ${Dimensions.units(0.5)}px;
`;

export const SubmitButton = styled(Button)`
  margin-left: ${Dimensions.units(18.5)}px;
`;

export const SubmitButtonWrapper = styled.div`
  margin-top: ${Dimensions.units(2.5)}px;
`;

export const RequiredAsterisk = styled.span`
  color: ${token('color.icon.danger', '#F15B50')};
`;

export const BillingStatementNote = styled.p`
  color: ${token('color.icon.subtle', '#626F86')};
`;

export const CCFormWrapper = styled.div`
  width: ${Dimensions.units(50)}px;
`;

export const StyledSearchBarWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: ${Dimensions.units(2)}px;
  border-top: 1px solid ${token('color.border', '#B3B9C4')};
  border-bottom: 1px solid ${token('color.border', '#B3B9C4')};
`;

export const StyledCheckboxWrapper = styled.div`
  display: inline-block;
  vertical-align: middle;
  margin-left: ${Dimensions.units(2)}px;

  && label {
    display: inline-grid;
    margin-right: ${Dimensions.units(2)}px;
  }

  && span {
    line-height: 1.5;
  }
`;

export const SearchInput = styled.div`
  width: ${Dimensions.units(30)}px;
  display: inline-block;
  margin-right: ${Dimensions.units(1)}px;
  font-size: 14px;
`;

export const SpinnerWrapper = styled.div<{ $marginTop?: number; $height?: number }>`
  display: flex;
  justify-content: center;
  align-items: baseline;
  margin-top: ${(props) => props.$marginTop && Dimensions.units(props.$marginTop)}px;
  height: ${(props) => props.$height && Dimensions.units(props.$height)}px;
`;

export const StyledTextParapgraph = styled.p`
  margin-top: ${Dimensions.units(1)}px;
  margin-bottom: ${Dimensions.units(1)}px;
`;

export const StyledWrapper = styled.div`
  display: flex;
  border-bottom: 1px solid #cccccc;
  padding: 10px;
  align-items: center;
`;

export const StyledValueWrapper = styled.div<{
  width?: string;
  textAlign?: string;
  isBold?: boolean;
}>`
  width: ${(props) => (props.width ? props.width : `unset`)};
  overflow-wrap: anywhere;
  margin-right: 10px;
  font-weight: ${(props) => (props.isBold ? `bold` : `unset`)};
`;

export const StyledRedSpan = styled.span<{ $marginLeft?: number }>`
  color: ${token('color.icon.danger', '#F15B50')};
  margin-left: ${(props) => props.$marginLeft && Dimensions.units(props.$marginLeft)}px;
`;

export const StyledTableRow = styled.tr`
  border-bottom: 1px solid #cccccc;
`;

export const StyledLinksWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const StyledLoadingButton = styled(Button)`
  margin-right: ${Dimensions.units(1.5)}px;
  width: ${Dimensions.units(18)}px;
`;

export const StyledSpan = styled.span<{
  $paddingLeft?: string;
  $margin?: string;
  $padding?: string;
}>`
  ${({ $paddingLeft }) => $paddingLeft && `padding-left: ${$paddingLeft}`};
  ${({ $margin }) => $margin && `margin: ${$margin}`};
  ${({ $padding }) => $padding && `padding: ${$padding}`};
`;

export const StyledNoLeftPaddingButton = styled(Button)<{ $paddingLeft?: number }>`
  padding-left: 0 !important;
`;

export const StyledTextfield = styled(Textfield)<{ $height?: number; $width?: number }>`
  height: ${(props) => Dimensions.units(props.$height ?? 2.5)}px !important;
  width: ${(props) => props.$width && Dimensions.units(props.$width)}px;
`;

export const StyledButton = styled(Button)<{ $marginRight?: string }>`
  ${({ $marginRight }) => $marginRight && `margin-right: ${$marginRight};`};
`;

export const StyledSpanWithLineHeight = styled.span<{ $marginLeft: string; $lineHeight?: string }>`
  ${({ $marginLeft }) => $marginLeft && `margin-left: ${$marginLeft} !important`};
  ${({ $lineHeight }) => $lineHeight && `line-height: ${$lineHeight} !important`};
`;

export const StyledParagraphWithTextAlign = styled.p<{ $textAlign: string }>`
  ${({ $textAlign }) => $textAlign && `text-align: ${$textAlign}`};
`;

export const StyledGreyParagraph = styled.p<{ $greyShade?: string }>`
  color: ${({ $greyShade }) => $greyShade ?? token('color.icon', '#44546F')};
`;

export const StyledDivWithTextAlign = styled.p<{ $textAlign: string }>`
  ${({ $textAlign }) => $textAlign && `text-align: ${$textAlign}`};
`;

export const DetailsValueLabelWrapper = styled.div`
  min-width: ${Dimensions.units(12.5)}px;
  text-align: right;
  margin-right: ${Dimensions.units(2)}px;
  color: ${token('color.text', '#172B4D')};
  white-space: nowrap;
`;

export const DetailLineWrapper = styled.div`
  display: flex;
  align-items: baseline;
`;

export const ContentBody = styled.div<{ $marginTop: number }>`
  margin-top: ${(props) => props.$marginTop && Dimensions.units(props.$marginTop)}px;
  display: flex;
  flex-direction: column;
  grid-gap: ${Dimensions.units(2.5)}px;
`;

export const TableRow = styled.tr`
  border-bottom: ${Dimensions.units(0.25)}px solid #dfe1e6;
`;
